import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=75ee500a&scoped=true"
var script = {}
import style0 from "./Documents.vue?vue&type=style&index=0&id=75ee500a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ee500a",
  null
  
)

export default component.exports